/* eslint-disable */
<template>
  <div>
    <Top :username="username" />
    <div class="content-wrapper back">
      <div class="container">
        <section class="content-header">
          <div class="row">
            <img
              src="assets/images/ug1.jpg"
              alt
              style="display:block;margin:auto"
              class="img img-responsive"
            />
            <h3
              style="text-align:center;font-weight:bold"
            >SCHOOL OF PUBLIC HEALTH, UNIVERSITY OF GHANA</h3>
            <h4
              style="text-align:center;font-weight:bold"
            >DASH Masters and PhD Fellowships in Adolescent Health - {{ academic_year }} Academic Year</h4>
          </div>
        </section>

        <section class="content" style="margin-bottom:20px">
          <form>
            <div class="box card-2">
              <div class="box-header">
                <h3 class="box-title">PERSONAL INFORMATION</h3>
              </div>

              <div class="box-body" style="padding:2rem 2rem">
				<div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="title">
                        Program applied for
                        <span style="color:red">*</span>
                      </label>
                      <select
                        v-validate="'required'"
                        name="program_applied"
                        id="program_applied"
                        class="form-control"
                        v-model="formdata.program_applied"
                        data-vv-as="Program Applied for"
                      >
                        <option value>--Choose--</option>
						<option value="MPH">MPH</option>
						<option value="PhD">PhD</option>
                      </select>
                      <span style="color:red;font-style:italic">{{ errors.first('program_applied') }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="title">
                        Title
                        <span style="color:red">*</span>
                      </label>
                      <select
                        v-validate="'required'"
                        name="title"
                        id="title"
                        class="form-control"
                        v-model="formdata.title"
                        data-vv-as="Title"
                      >
                        <option value>Select Title</option>
                        <option
                          v-for="(t,index) in titles"
                          :value="t.title"
                          :key="index"
                        >{{t.title}}</option>
                      </select>
                      <span style="color:red;font-style:italic">{{ errors.first('title') }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="surname">
                        Surname
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:100'"
                        type="text"
                        name="surname"
                        class="form-control"
                        v-model="formdata.surname"
                        id="surname"
                        placeholder="Surname"
                        data-vv-as="Surname"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('surname') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="othernames">
                        Othernames
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:150'"
                        type="text"
                        name="othernames"
                        class="form-control"
                        v-model="formdata.othernames"
                        id="othernames"
                        placeholder="Othernames"
                        data-vv-as="Othernames"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('othernames') }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="gender">
                        Gender
                        <span style="color:red">*</span>
                      </label>
                      <select
                        v-validate="'required'"
                        name="gender"
                        id="gender"
                        class="form-control"
                        v-model="formdata.gender"
                        data-vv-as="Gender"
                      >
                        <option value>Select gender</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </select>
                      <span style="color:red;font-style:italic">{{ errors.first('gender') }}</span>
                    </div>
                  </div>
                </div>

				<div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="dob">
                        Date of Birth
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required'"
                        type="date"
                        name="dob"
                        class="form-control"
                        v-model="formdata.dob"
                        id="dob"
                        placeholder="Date of Borth"
                        data-vv-as="Date of Birth"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('dob') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="place_birth">
                        Place of Birth
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required'"
                        type="text"
                        name="place_birth"
                        class="form-control"
                        v-model="formdata.place_birth"
                        id="place_birth"
                        placeholder="Place of Birth"
                        data-vv-as="Place of Birth"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('place_birth') }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="phone">
                        Mobile Phone Number
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:13'"
                        type="text"
                        name="phone"
                        class="form-control"
                        v-model="formdata.phone"
                        id="phone"
                        placeholder="Primary Mobile Phone Number"
                        data-vv-as="Phone Number"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('phone') }}</span>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="email">Email</label>
                      <input
                        type="email"
                        name="email"
                        class="form-control"
                        v-model="formdata.email"
                        id="email"
                        placeholder="Email Address"
                        readonly
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="address">
                        Postal Address
                        <span style="color:red">*</span>
                      </label>
                      <textarea
                        v-validate="'required|max:150'"
                        name="address"
                        class="form-control"
                        v-model="formdata.address"
                        id="address"
                        placeholder="Postal Address"
                        data-vv-as="Postal Address"
                        rows="5"
                        style="resize:none"
                      ></textarea>
                      <span style="color:red;font-style:italic">{{ errors.first('address') }}</span>
                    </div>
                  </div>
                </div>

				<div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="aca_bkground">
                           Previous academic background 
                        <span style="color:red"></span>
                      </label>
                      <textarea
                    
                        name="aca_bkground"
                        class="form-control"
                        v-model="formdata.aca_bkground"
                        id="aca_bkground"
                        placeholder="Previous academic background"
                        rows="5"
						cols="8"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="isemployed">
                        Are you currently employed
                        <span style="color:red">*</span>
                      </label>
                      <select
                        name="isemployed"
                        id="isemployed"
                        class="form-control"
                        v-validate="'required'"
                        data-vv-as="Currently Employed"
                        v-model="formdata.isemployed"
                      >
                        <option value>Please select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                      <span style="color:red;font-style:italic">{{ errors.first('isemployed') }}</span>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="formdata.isemployed==='Yes'">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="position">
                        Job Title / Position
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:80'"
                        type="text"
                        name="position"
                        class="form-control"
                        v-model="formdata.position"
                        id="position"
                        placeholder="Position"
                        data-vv-as="Position"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('position') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="employername">
                        Name of Institution
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:150'"
                        type="text"
                        name="employername"
                        class="form-control"
                        v-model="formdata.employername"
                        id="employername"
                        placeholder="Name of Institution"
                        data-vv-as="Name of Institution"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('employername') }}</span>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="employeremail">Instution Email Address</label>
                      <input
                        type="email"
						v-validate="'email'"
                        name="employeremail"
                        class="form-control"
                        v-model="formdata.employeremail"
                        id="employeremail"
                        placeholder="Instution Email Address"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="employeraddress">
                        Institution Postal Address
                        <!-- <span style="color:red">*</span> -->
                      </label>
                      <textarea
                        name="employeraddress"
                        class="form-control"
                        v-model="formdata.employeraddress"
                        id="employeraddress"
                        placeholder="Institution Postal Address"
                        data-vv-as="Institution Postal Address"
                        rows="5"
                        style="resize:none"
                      ></textarea>
                      <!-- <span
                        style="color:red;font-style:italic"
                      >{{ errors.first('employeraddress') }}</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="box card-2">
              <div class="box-header">
                <h3 class="box-title">EDUCATIONAL BACKGROUND</h3>
              </div>
              <div class="box-body" style="padding:2rem 2rem">
				<h4 style="color:red">Post-Secondary Education (Begin with most recent and include relevant short-term technical or professional training.)</h4>
               
			   <hr>	
				<div class="row" v-for="i in educount" :key="i">
                  <div class="col-sm-3">
                    <!-- <div class="row">
                              <div class="col-sm-6"></div>
                              <div class="col-sm-6"></div>
                    </div>-->
                    <div class="form-group">
                      <label for="edudates">
                        Dates
                        <span style="color:red">*</span>
                      </label><br>
                      <!-- <input
                        v-validate="'required'"
                        type="text"
                        name="edudates"
                        class="form-control"
                        v-model="formdata['edudates'+i]"
                        id="edudates"
                        placeholder="Dates"
                        data-vv-as="Dates"
                      /> -->
					  <date-range-picker opens="center" :locale-data="{ separator: ' - ', format: 'YYYY-MM-DD' }" :showWeekNumbers=true :showDropdowns=true v-model="formdata['edudates'+i]"></date-range-picker>
                      <!-- <span style="color:red;font-style:italic">{{ errors.first('edudates') }}</span> -->
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="eduattended">
                        Institution Attended
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:150'"
                        type="text"
                        :name="'eduattended'+i"
                        class="form-control"
                        v-model="formdata['eduattended'+i]"
                        id="eduattended"
                        placeholder="Institution Attended"
                        data-vv-as="Institution Attended"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('eduattended'+i) }}</span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="edumajorsubject">
                        Area of specialization (Major subject)
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:150'"
                        type="text"
                        :name="'edumajorsubject'+i"
                        class="form-control"
                        v-model="formdata['edumajorsubject'+i]"
                        id="edumajorsubject"
                        placeholder="Major Subjects"
                        data-vv-as="Major Subjects"
                      />
                      <span
                        style="color:red;font-style:italic"
                      >{{ errors.first('edumajorsubject'+i) }}</span>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="edudegreecompleted">
                        Degree Completed
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:150'"
                        type="text"
                        :name="'edudegreecompleted'+i"
                        class="form-control"
                        v-model="formdata['edudegreecompleted'+i]"
                        id="edudegreecompleted"
                        placeholder="Degree Completed "
                        data-vv-as="Degree Completed "
                      />
                      <span
                        style="color:red;font-style:italic"
                      >{{ errors.first('edudegreecompleted'+i) }}</span>
                    </div>
                  </div>
                </div>

                <button :disabled="educount===5" class="btn btn-success" type="button" @click="educount++">Add More</button>&nbsp;&nbsp;
                <button
                  class="btn btn-danger"
                  type="button"
                  @click="educount--"
                  v-show="educount!==1"
                >Remove</button>
              </div>
            </div>

            <div class="box card-2">
              <div class="box-header">
                <h3 class="box-title">UPLOAD PASSPORT/PHOTO</h3>
              </div>
              <div class="box-body" style="padding:2rem 2rem">
                <picture-input
                  ref="pictureInput"
                  width="250"
                  height="250"
                  margin="16"
                  accept="image/*"
				  :prefill="prefill"
                  button-class="btn btn-primary"
                  remove-button-class="btn btn-danger box-shadow-3"
                  :removable="true"
                  :z-index="100"
                  :custom-strings="{drag: 'Drag image<br>or<br>Click to upload passport photo'}"
				  @remove="removeImage"
				  @change="ImageChange"
                ></picture-input>
              </div>
            </div>

            <div class="box">
              <div class="box-header">
                <h3 class="box-title">EMPLOYMENT HISTORY</h3>
              </div>
              <div class="box-body" style="padding:2rem 2rem">
				<h4 style="color:red">Relevant work experience (Begin with most recent employment, and include all current jobs)</h4>
				<hr>
                <div class="row" v-for="i in empcount" :key="i">
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="empdates">
                        Dates
                        <span style="color:red">*</span>
                      </label><br>
                      <!-- <input
                        v-validate="'required'"
                        type="text"
                        name="empdates"
                        class="form-control"
                        v-model="formdata['empdates'+i]"
                        id="empdates"
                        placeholder="Dates"
                        data-vv-as="Dates"
                      /> -->
					  <date-range-picker opens="center" :locale-data="{ separator: ' - ', format: 'YYYY-MM-DD' }" :showWeekNumbers=true :showDropdowns=true v-model="formdata['empdates'+i]"></date-range-picker>

                      <!-- <span style="color:red;font-style:italic">{{ errors.first('empdates') }}</span> -->
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="empposition">
                        Postion/Title
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:150'"
                        type="text"
                        :name="'empposition'+i"
                        class="form-control"
                        v-model="formdata['empposition'+i]"
                        id="empposition"
                        placeholder="Position"
                        data-vv-as="Position"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('empposition'+i) }}</span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="empemployer">
                        Employer
                        <span style="color:red">*</span>
                      </label>
                      <input
                        v-validate="'required|max:150'"
                        type="text"
                        :name="'empemployer'+i"
                        class="form-control"
                        v-model="formdata['empemployer'+i]"
                        id="empemployer"
                        placeholder="Employer"
                        data-vv-as="Employer"
                      />
                      <span style="color:red;font-style:italic">{{ errors.first('empemployer'+i) }}</span>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="empcountry">
                        City / Country
                        <span style="color:red">*</span>
                      </label>
                       <input
                        v-validate="'required'"
                        type="text"
                        :name="'empcountry'+i"
                        class="form-control"
                        v-model="formdata['empcountry'+i]"
                        id="empcountry"
                        placeholder="City / Country"
                        data-vv-as="City / Country"
                      /> 
					   <!-- <select
                        v-validate="'required'"
                        :name="'empcountry'+i"
                        id="empcountry"
                        class="form-control"
                        v-model="formdata['empcountry'+i]"
                      >
                        <option value=''>Select Country</option>
                        <option
                          v-for="(c,index) in country"
                          :value="c.country"
                          :key="index"
                        >{{c.country}}</option>
                      </select> -->
                      <span style="color:red;font-style:italic">{{ errors.first('empcountry'+i) }}</span>
                    </div>
                  </div>
                </div>

                <button :disabled="empcount===5" class="btn btn-success" type="button" @click="addMoreEmp">Add More</button>&nbsp;&nbsp;
                <button
                  class="btn btn-danger"
                  type="button"
                  @click="removeEmp"
                  v-show="empcount!==1"
                >Remove</button>
              </div>
            </div>

            <div class="box card-2">
              <div class="box-header">
                <h3 class="box-title">DOCUMENTS TO UPLOAD</h3>
              </div>
              <div class="box-body" style="padding:2rem 2rem">
                <h3>These documents should be submitted:</h3>
				<h3 style="color:red">Note: All document should be submitted in PDF format</h3>
                <table class="table">
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td style="width:40%">A cover letter explaining your interest in the project.</td>
                      <td>
                        <input
                          type="file"
                          id="coverletter"
                          class="form-control"
                          name="coverletter"
                          @change="selectDocuments('coverletter',$event)"
                        />
                        <div
                          class="attachment"
                          v-if="docs['coverletter'] && docs['coverletter']['selected']"
                        >
                          <div class="row">
                            <div class="col-sm-1">
                              <i class="fa fa-file fa-2x primary"></i>
                            </div>
                            <div class="col-sm-9">
                              <p>{{docs['coverletter']['name']}}</p>
                              <p class="filename">{{docs['coverletter']['size']}}</p>
                            </div>
                            <div class="col-sm-1">
                              <button
                                type="button"
                                @click="removeDocument('coverletter')"
                                class="btn btn-primary"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button
                          :disabled="['coverletter']['text']==='Uploading...'"
                          v-show="docs['coverletter']['selected']"
                          type="button"
                          class="btn btn-success"
                          v-if="!docs['coverletter']['hasuploaded']"
                          @click="uploadFile('coverletter')"
                        >{{docs['coverletter']['text']}}</button>
                        <span class="label label-success" v-else>Uploaded</span>
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Complete curriculum vitae (CV), including statistical analysis and research experience.</td>
                      <td>
                        <input
                          type="file"
                          id="cv"
                          class="form-control"
                          name="cv"
                          @change="selectDocuments('cv',$event)"
                        />

                        <div class="attachment" v-if="docs['cv'] && docs['cv']['selected']">
                          <div class="row">
                            <div class="col-sm-1">
                              <i class="fa fa-file fa-2x primary"></i>
                            </div>
                            <div class="col-sm-9">
                              <p>{{docs['cv']['name']}}</p>
                              <p class="filename">{{docs['cv']['size']}}</p>
                            </div>
                            <div class="col-sm-1">
                              <button
                                type="button"
                                @click="removeDocument('cv')"
                                class="btn btn-primary"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button
                          :disabled="['cv']['text']==='Uploading...'"
                          type="button"
                          class="btn btn-success"
                          v-if="!docs['cv']['hasuploaded']"
                          @click="uploadFile('cv')"
                          v-show="docs['cv']['selected']"
                        >{{docs['cv']['text']}}</button>
                        <span class="label label-success" v-else>Uploaded</span>
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Personal Statement.</td>
                      <td>
                        <input
                          type="file"
                          id="essay"
                          class="form-control"
                          name="essay"
                          @change="selectDocuments('essay',$event)"
                        />
                        <div class="attachment" v-if="docs['essay'] && docs['essay']['selected']">
                          <div class="row">
                            <div class="col-sm-1">
                              <i class="fa fa-file fa-2x primary"></i>
                            </div>
                            <div class="col-sm-9">
                              <p>{{docs['essay']['name']}}</p>
                              <p class="filename">{{docs['essay']['size']}}</p>
                            </div>
                            <div class="col-sm-1">
                              <button
                                type="button"
                                @click="removeDocument('essay')"
                                class="btn btn-primary"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button
                          :disabled="['essay']['text']==='Uploading...'"
                          type="button"
                          class="btn btn-success"
                          v-if="!docs['essay']['hasuploaded']"
                          @click="uploadFile('essay')"
                          v-show="docs['essay']['selected']"
                        >{{docs['essay']['text']}}</button>
                        <span class="label label-success" v-else>Uploaded</span>
                      </td>
                    </tr>

					<tr>
                      <td>4</td>
                      <td>Proof of application to the University of Ghana</td>
                      <td>
                        <input
                          type="file"
                          id="admissionletter"
                          class="form-control"
                          name="admissionletter"
                          @change="selectDocuments('admissionletter',$event)"
                        />
                        <div class="attachment" v-if="docs['admissionletter'] && docs['admissionletter']['selected']">
                          <div class="row">
                            <div class="col-sm-1">
                              <i class="fa fa-file fa-2x primary"></i>
                            </div>
                            <div class="col-sm-9">
                              <p>{{docs['admissionletter']['name']}}</p>
                              <p class="filename">{{docs['admissionletter']['size']}}</p>
                            </div>
                            <div class="col-sm-1">
                              <button
                                type="button"
                                @click="removeDocument('admissionletter')"
                                class="btn btn-primary"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button
                          :disabled="['admissionletter']['text']==='Uploading...'"
                          type="button"
                          class="btn btn-success"
                          v-if="!docs['admissionletter']['hasuploaded']"
                          @click="uploadFile('admissionletter')"
                          v-show="docs['admissionletter']['selected']"
                        >{{docs['admissionletter']['text']}}</button>
                        <span class="label label-success" v-else>Uploaded</span>
                      </td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td>At least one (1) letter of recommendation</td>
                      <td>
                        <input
                          type="file"
                          id="recommendation"
                          class="form-control"
                          name="recommendation"
                          @change="selectDocuments('recommendation',$event)"
                        />

                        <div
                          class="attachment"
                          v-if="docs['recommendation'] && docs['recommendation']['selected']"
                        >
                          <div class="row">
                            <div class="col-sm-1">
                              <i class="fa fa-file fa-2x primary"></i>
                            </div>
                            <div class="col-sm-9">
                              <p>{{docs['recommendation']['name']}}</p>
                              <p class="filename">{{docs['recommendation']['size']}}</p>
                            </div>
                            <div class="col-sm-1">
                              <button
                                type="button"
                                @click="removeDocument('recommendation')"
                                class="btn btn-primary"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button
                          :disabled="['recommendation']['text']==='Uploading...'"
                          type="button"
                          class="btn btn-success"
                          v-if="!docs['recommendation']['hasuploaded']"
                          @click="uploadFile('recommendation')"
                          v-show="docs['recommendation']['selected']"
                        >{{docs['recommendation']['text']}}</button>
                        <span class="label label-success" v-else>Uploaded</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

				

            <div class="row text-center" style="justify-content:center;">
                <button type="button" class="btn btn-success" @click="saveinformation('continue')">Save and Continue</button>&nbsp;&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-primary"
				  @click="saveinformation('exit')"
                >Save and Exit</button>&nbsp;&nbsp;&nbsp;&nbsp;
				<router-link class="btn btn-danger" to='/summary'>View Summary</router-link>
              
            </div>
          </form>
        </section>
      </div>
    </div>

	
    <Footer />
	 <BlockUI v-show="isLoading" message="Please wait. Saving..."></BlockUI>
  </div>
</template>

<script>

import Top from "./partials/Top.vue";
import Footer from "./partials/Footer.vue";
import PictureInput from "vue-picture-input";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'

export default {
  name: "Mainform",
  components: {
    Top,
    Footer,
	PictureInput,
	DateRangePicker
  },
  data() {
    return {
		dateRange: { 
        startDate:moment().format('YYYY-MM-DD'),
        endDate: moment().add(60, 'days').format('YYYY-MM-DD')
      },
		isLoading:false,
		academic_year:"2024/2025",
      prefill:null,
      educount: 1,
      empcount: 1,
      toggledisabled: false,
      afterregistration: false,
      username: "",
      exts: ["pdf", "docs", "docx", "png", "jpg", "jpeg"],
      titles: [],
      country: [],
      docs: {
        coverletter: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
        cv: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
        essay: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
		admissionletter: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
        recommendation: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        }
      },
      formdata: {
        id: "",
        title: "",
        surname: "",
        othernames: "",
        gender: "",
        nationality: "",
        email: "",
        phone: "",
		program_applied:"",
        address: "",
		place_birth:'',
		dob:'',
		aca_bkground:'',

        isemployed: "",
        position: "",
        employername: "",
        employeremail: "",
        employeraddress: "",

		image: "",
		

		empdates1:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		empposition1:'',
		empemployer1:'',
		empcountry1:'',

		empdates2:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		empposition2:'',
		empemployer2:'',
		empcountry2:'',

		empdates3:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		empposition3:'',
		empemployer3:'',
		empcountry3:'',

		empdates4:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		empposition4:'',
		empemployer4:'',
		empcountry4:'',

		empdates5:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		empposition5:'',
		empemployer5:'',
		empcountry5:'',

		edudates1:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		eduattended1:'',
		edumajorsubject1:'',
		edudegreecompleted1:'',

		edudates2:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		eduattended2:'',
		edumajorsubject2:'',
		edudegreecompleted2:'',

		edudates3:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		eduattended3:'',
		edumajorsubject3:'',
		edudegreecompleted3:'',

		edudates4:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		eduattended4:'',
		edumajorsubject4:'',
		edudegreecompleted4:'',

		edudates5:{ startDate:moment().format('YYYY-MM-DD'),endDate: moment().add(60, 'days').format('YYYY-MM-DD')},
		eduattended5:'',
		edumajorsubject5:'',
		edudegreecompleted5:''

      }
    };
  },
  methods: {
	  addMoreEmp(){
		  this.empcount++;

	  },
	  removeEmp(){
		  this.empcount--;
	  },
	  updateValues(){
		  //console.log(data);
		 // this.formdata[data] = moment($event.startDate).format('YYYY-MM-DD')+' - '+moment($event.endDate).format('YYYY-MM-DD')
	  },
	  checkOpen($event){
		  console.log($event)
	  },
    callExitSwal(){
		var _this = this;
      this.$swal({
        title: "Success",
        text: "Information Saved Successfully. Do you still want to Exit?",
        icon: "success",
        closeOnClickOutside: true,
        buttons: {
          cancel: {
            text: "Yes, Exit App",
            value: null,
            visible: true,
            closeModal: true
          },
          confirm: {
            text: "No, Continue",
            value: true,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (isConfirm) {
        if (isConfirm) {
		  //_this.$router.push('summary');
          _this.$router.push('summary');
        } else {
		localStorage.removeItem('user');
          localStorage.removeItem('apikey');
          _this.$router.push('login');
        }
      });
    },
	  fillImage(){
		  let ret  = this.formdata.image===null  || this.formdata.image==='' ? null : this.appenv+'/images/'+this.formdata.image

		  console.log(ret);
		  return ret;
	  },
    removeImage: function removeImage() {
      this.formdata.image = "";
    },
    ImageChange: function ImageChange(image) {
      if (this.$refs.pictureInput.file) {
        this.formdata.image = this.$refs.pictureInput.file;
      } else {
        this.formdata.image = image;
      }

      window.URL = window.URL || window.webkitURL;
      var img = new Image();
      var me = this;
      img.src = window.URL.createObjectURL(this.formdata.image);

      img.onload = function() {
        var width = img.naturalWidth,
          height = img.naturalHeight;

        if (width > 600 || height > 800 || height < 100 || width < 100) {
          alert(
            "Dimensions Should be Maximum 600px by 800px and minimum 100px by 100px.Please Upload a Different one"
          );
          me.formdata.image = "";
        }
      };
    },
    selectDocuments: function(type, $event) {
      var file = $event.target.files[0];
      if (this.exts.indexOf(file.name.split(".").pop()) === -1) {
        alert("Only PDF,Images and Docx files are accepted");
        document.getElementById(type).value = "";
        return;
      }
      this.docs[type]["file"] = file;
      this.docs[type]["selected"] = true;
      this.docs[type]["name"] = file.name;
      this.docs[type]["size"] = file.size;
      this.docs[type]["hasuploaded"] = false;
    },
    removeDocument: function(type) {
      if (confirm("Are you sure you want to remove the file?")) {
        this.docs[type]["file"] = null;
        this.docs[type]["selected"] = false;
        this.docs[type]["name"] = null;
        this.docs[type]["size"] = null;
        this.docs[type]["text"] = "Upload";
        this.docs[type]["hasuploaded"] = false;
        document.getElementById(type).value = "";
        this.$http
          .get(
            this.appenv.baseurl +
              "/deletedocument?id=" +
              this.formdata.id +
              "&type=" +
              type
          )
          .then()
          .catch();
      }
    },
    uploadFile(type) {
      let me = this;
      let formData = new FormData();
      formData.append(type, this.docs[type]["file"]);
      formData.append("type", type);
      formData.append("id", this.formdata.id);
      this.docs[type]["text"] = "Uploading...";
      this.$http
        .post(this.appenv.baseurl + "/uploadfile", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          if (res && res.data.status === "success") {
            me.docs[type]["name"] = res.data.filename;
            me.docs[type]["hasuploaded"] = true;
            me.docs[type]["selected"] = true;
          } else {
            me.docs[type]["hasuploaded"] = false;
            me.docs[type]["text"] = "Upload";
          }
        });
    },
    fetchTitle() {
      this.$http
        .get(this.appenv.baseurl + "/title")
        .then(res => {
          this.titles = res.data.title;
		  if(res.data.academic_year){
			this.academic_year = res.data.academic_year
		  }
        })
        .catch();
    },
    fetchCountry() {
      this.$http
        .get(this.appenv.baseurl + "/country")
        .then(res => {
          this.country = res.data.country;
        })
        .catch();
	},
	fetchDocs(){
		let _this = this;
		this.$http
        .get(this.appenv.baseurl + "/fetchdocs?id="+this.formdata.id)
        .then(res => {
		  let docs = res.data.docs;
		  for(var i=0;i<docs.length;i++){
			  switch(docs[i]['type']){
				  case 'coverletter':
					  //	_this.docs[type]["file"] = file;
						_this.docs['coverletter']["selected"] = true;
						_this.docs['coverletter']["name"] = docs[i]['name'];
						_this.docs['coverletter']["size"] = 0;
						_this.docs['coverletter']["hasuploaded"] = true;
				  break;
				  case 'cv':
					  	_this.docs['cv']["selected"] = true;
						_this.docs['cv']["name"] = docs[i]['name'];
						_this.docs['cv']["size"] = 0;
						_this.docs['cv']["hasuploaded"] = true;
				  break;
				  case 'essay':
					  	_this.docs['essay']["selected"] = true;
						_this.docs['essay']["name"] = docs[i]['name'];
						_this.docs['essay']["size"] = 0;
						_this.docs['essay']["hasuploaded"] = true;
				  break;
				  case 'admissionletter':
					  	_this.docs['admissionletter']["selected"] = true;
						_this.docs['admissionletter']["name"] = docs[i]['name'];
						_this.docs['admissionletter']["size"] = 0;
						_this.docs['admissionletter']["hasuploaded"] = true;
				  break;
				  case 'recommendation':
					  _this.docs['recommendation']["selected"] = true;
						_this.docs['recommendation']["name"] = docs[i]['name'];
						_this.docs['recommendation']["size"] = 0;
						_this.docs['recommendation']["hasuploaded"] = true;
				  break;
				  default:
				  break;
			  }
		  }
        })
        .catch();
	},
	fetchEduHistory() {
		let _this  = this;
      this.$http
        .get(this.appenv.baseurl + "/fetchemphistory?id=" + this.formdata.id)
        .then(res => {
          if (res.data) {
			//this.emphistory = res.data.emphistory;
			let data = res.data.emphistory;
			_this.empcount = data.length===0? 1: data.length;
			for(var i=1;i<=data.length;i++){
				 _this.formdata['empdates'+i]['startDate'] = data[i-1]['startDate'];
				  _this.formdata['empdates'+i]['endDate'] = data[i-1]['endDate'];
				  _this.formdata['empposition'+i] = data[i-1]['position'];
				   _this.formdata['empemployer'+i] = data[i-1]['employer'];
				    _this.formdata['empcountry'+i] = data[i-1]['country'];
			}
            
          }
        })
        .catch();
    },
    fetchEmpHistory() {
		let _this  = this;
      this.$http
        .get(this.appenv.baseurl + "/fetchedubackground?id=" + this.formdata.id)
        .then(res => {
          if (res.data) {
			let data = res.data.eduhistory;
			_this.educount = data.length===0 ? 1 : data.length;
			for(var i=1;i<=data.length;i++){
				 _this.formdata['edudates'+i]['startDate'] = data[i-1]['startDate'];
				 _this.formdata['edudates'+i]['endDate'] = data[i-1]['endDate'];
				  _this.formdata['eduattended'+i] = data[i-1]['institution'];
				   _this.formdata['edumajorsubject'+i] = data[i-1]['subjects'];
				    _this.formdata['edudegreecompleted'+i] = data[i-1]['degree'];
			}
			
          }
        })
        .catch();
	},

    pickBiodata() {
      let me = this;
      this.$http
        .get(this.appenv.baseurl + "/fetchprofile?id=" + this.formdata.id)
        .then(res => {
          let user = res.data.user;
          Object.keys(user).forEach(function(item) {
            me.formdata[item] = user[item] === null ? "" : user[item];
		  });
		  me.prefill  = me.formdata.image===null  || me.formdata.image==='' ? null : this.formdata.image;
		})
        .catch();
    },
    saveinformation: function(type) {
      var _this = this;
      this.$validator.validate().then(valid => {
        if (valid) {
			_this.isLoading = true;
          _this.toggledisabled = true;
          let formData = new FormData();

          Object.keys(_this.formdata).forEach(function(item) {
            formData.append(item, _this.formdata[item]);
          });
          formData.append("educount", _this.educount);
		  formData.append("empcount", _this.empcount);
		  for(var i=1;i<=_this.educount;i++){
			  moment().format('YYYY-MM-DD')
			   formData.append('edustartDate'+i, moment(_this.formdata['edudates'+i]['startDate']).format('YYYY-MM-DD'))
			  formData.append('eduendDate'+i, moment(_this.formdata['edudates'+i]['endDate']).format('YYYY-MM-DD'))
		  }
		  for(var j=1;j<=_this.empcount;j++){
			  formData.append('empstartDate'+j, moment(_this.formdata['empdates'+j]['startDate']).format('YYYY-MM-DD'))
			  formData.append('empendDate'+j, moment(_this.formdata['empdates'+j]['endDate']).format('YYYY-MM-DD'))
		  }
          //console.log(formData.getAll());
          this.$http
            .post(this.appenv.baseurl + "/saveinformation", formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(result => {
			  _this.toggledisabled = false;
			  _this.isLoading = false;
              if (result.data.status === "success") {
                // this.$swal(
                //   "Success",
                //   "Your Information has been saved Successfully",
                //   "success"
				// );
				if(type==='continue'){
					this.$router.push('summary');
				}else{
					_this.callExitSwal();
				}
				//this.$router.push('summary');
                //   reset localstorage
              } else {
                this.afterregistration = false;
                this.$swal(
                  "Oops",
                  "Oops Registration was not successful.. Please try again",
                  "error"
                );
              }
            })
            .catch(() => {
			  _this.toggledisabled = false;
			  _this.isLoading = false;
              this.afterregistration = false;
              this.$swal(
                "Oops",
                "Oops Registration was not successful.. Please try again",
                "error"
              );
              //console.log(err)
            });
        } else {
          Object.keys(this.fields).forEach(key => {
            if (this.fields[key].dirty || this.fields[key].invalid) {
              //console.log(this.fields[key],key,this.fields[key].error);
              this.$swal(
                "Alert",
                "Please check and fill all required fields",
                "info"
              );
			  console.log(valid);
            }
          });
        }
      });
    }
  },
  mounted: function() {
    if (localStorage.getItem("user") && localStorage.getItem("apikey")) {
      //console.log(localStorage.getItem('user')===null);
      if (
        localStorage.getItem("user") === "undefined" ||
        localStorage.getItem("user") === null
      ) {
        localStorage.removeItem("apikey");
        localStorage.removeItem("user");
        this.$router.push("login");
      } else {
        var user = JSON.parse(localStorage.getItem("user"));
        var me = this;
        Object.keys(user).forEach(function(item) {
          me.formdata[item] = user[item] === null ? "" : user[item];
        });
        this.fetchTitle();
		this.fetchCountry();
		this.pickBiodata();
		this.fetchEduHistory();
		this.fetchEmpHistory();
		this.fetchDocs();
        this.username = me.formdata.surname;
        //console.log(me.formdata.academicproof);
      }
    } else {
      localStorage.removeItem("apikey");
      localStorage.removeItem("user");
      this.$router.push("login");
    }
  }
};
</script>

<style>
.back {
  background: #ffffff;
}
.bg-image-full {
  background: no-repeat center center scroll;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  -o-background-size: cover;
}
.attachment {
  border-radius: 3px;
  background: #f4f4f4;
  padding: 10px;
}
</style>
